// extracted by mini-css-extract-plugin
export default {"timer":"Timer_timer__OaSPc","light":"Timer_light__fU7ln","dark":"Timer_dark__-ZL4E","warning":"Timer_warning__gfDhB","danger":"Timer_danger__6Ja3q"};